// @flow

import React, { type Node } from 'react';

import klapIconSrc from './klap-icon.svg';
import { Icon, IconWrapper, BrandsIconsWrapper } from '../../../../../../../../commons/atoms';

export function DisplayKlapBrand(): Node {
  return (
    <BrandsIconsWrapper>
      <IconWrapper>
        <Icon src={klapIconSrc} alt="klap" />
      </IconWrapper>
    </BrandsIconsWrapper>
  );
}
